import Clear from './../layouts/Clear.vue';

export default {
  path: '/subcategories',
  component: Clear,
  children: [
    {
      path: '',
      name: 'subcategories.index',
      component: () => import('@/views/subcategories/index.vue'),
    },
  ],
};
